import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-nav-item-content-fa9f0",
  "use": "icons-nav-item-content-fa9f0-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"icons-nav-item-content-fa9f0\"><path d=\"M10.734 2.6h2.667v11.866h-10.8V2.6h2.666V1.533h5.467zM3.801 13.266h8.4V3.8h-1.467v1.067H5.267V3.8H3.801Zm4.2-2.533H5.335v-1.2h2.666ZM10.668 8.6H5.335V7.4h5.333ZM6.467 3.667h3.067v-.934H6.467Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol